<template>
  <transition name="modal" id="contact-info-dialog">
    <div>
      <DxPopup
        :height="popupHeight"
        width="100vw"
        :hide-on-outside-click="false"
        :show-close-button="true"
        :visible="showPopup"
        position="bottom"
        @hidden="$emit('hidden')"
        :wrapper-attr="popupAttributes"
      >
        <template #title>
          <div class="map-filter-title">
            <div class="map-filter-close">
              <img src="@/assets/images/icons/dialog-close-white.svg" @click="closeDialog" />
            </div>
          </div>
        </template>

        <template #content>
          <div class="map-filter-container">
            <DxTabPanel
              :data-source="filterTabs"
              :selected-item="currentColorFilterItem"
              :selected-index="currentColorFilterStep"
              @selection-changed="mainTabSelectionChanged($event)"
              :show-nav-buttons="true"
              class="map-filter-tabs"
              item-title-template="tabTitle"
              item-template="tabContent"
            >
              <template #tabTitle="{ data }">
                {{ data.text }}
              </template>
              <template #tabContent="{ data: mainStep }">
                <div>
                  <DxScrollView v-show="mainStep.id == 'STRATIFICARE'">
                    <div class="layer-detail-content">
                      <div class="ld-input-holder">
                        <div class="input_label">Stratificare dupa</div>
                        <div>
                          <DxSelectBox
                            v-model="formData.colorByType"
                            class="filter-input"
                            :items="colorByTypes"
                            display-expr="name"
                            value-expr="code"
                            @value-changed="onColorByTypeChanged"
                          />
                        </div>
                      </div>
                      <div class="ld-input-holder" v-if="selectedColorByType?.code == 'WORK'">
                        <div class="input_label">Selectează data</div>
                        <div>
                          <functional-calendar
                            class="test_calendar_class"
                            :date-format="'yyyy-mm-dd'"
                            :is-date-range="true"
                            v-model="calendar"
                            :change-month-function="true"
                            :change-year-function="true"
                          ></functional-calendar>
                        </div>
                      </div>
                      <div class="ld-input-holder" v-if="selectedColorByType?.code">
                        <div class="input_label capitalize" v-if="selectedColorByType?.code == 'SEASON'">
                          {{ selectedColorByType.name.toLowerCase() }}
                        </div>
                        <div class="input_label" v-else>Tip {{ selectedColorByType.name.toLowerCase() }}</div>
                        <div>
                          <div
                            v-for="culture in cultures"
                            :key="culture.uuid"
                            class="input_color_holder"
                            v-show="selectedColorByType?.code == 'CULTURE'"
                          >
                            <DxCheckBox name="culture" v-model="culture.selected" :element-attr="checkBoxAttributes" />
                            <div :style="bgColor(culture)" class="input_color_point"></div>
                            <div class="input_color_name capitalize">{{ culture.name }}</div>
                          </div>
                          <div v-show="selectedColorByType?.code == 'WORK'">
                            <DxRadioGroup
                              ref="workRadio"
                              :dataSource="localLayerWorks"
                              v-model:value="formData.work_uuid"
                              display-expr="name"
                              :element-attr="radioGroupAttributes"
                              item-template="radio"
                            >
                              <template #radio="{ data }">
                                <div class="input_color_holder">
                                  <div v-if="false" :style="bgColor(data)" class="input_color_point"></div>
                                  <div class="input_color_name">{{ data.name }}</div>
                                </div>
                              </template>
                            </DxRadioGroup>
                          </div>
                          <div
                            v-for="(season, index) in seasons"
                            :key="index"
                            class="input_color_holder"
                            v-show="selectedColorByType?.code == 'SEASON'"
                          >
                            <DxCheckBox name="season" v-model="season.selected" :element-attr="checkBoxAttributes" />
                            <div :style="bgColor(season)" class="input_color_point"></div>
                            <div class="input_color_name">{{ season.name }}</div>
                          </div>
                          <div
                            v-for="legalEntity in legalEntities"
                            :key="Math.random()"
                            class="input_color_holder"
                            v-show="selectedColorByType?.code == 'LEGAL_ENTITY'"
                          >
                            <DxCheckBox name="legalEntity" v-model="legalEntity.selected" :element-attr="checkBoxAttributes" />
                            <div :style="bgColor(legalEntity)" class="input_color_point"></div>
                            <div class="input_color_name">{{ legalEntity.name }}</div>
                          </div>

                          <layer-color-filter-element
                            :items="colorFilterItems"
                            v-show="selectedColorByType?.code == 'PRODUCT'"
                            @onSelect="onProductSelected"
                            :onDateSelected="onProductFilterDateSelected"
                            :show-date-range-checkbox="true"
                            :date-range-checkbox-value="filterProductsBySelectedDateRange"
                            :date-range-checkbox-label="$t('layer_colorizing.only_products_in_selected_date_range')"
                            @onDateRangeCheckboxChanged="onProductDateRangeCheckboxChanged"
                            :error-message="colorFilterElementErrorMessage"
                          />

                          <layer-color-filter-element
                            :items="colorFilterItems"
                            v-show="selectedColorByType?.code == 'WORK_MACHINE'"
                            @onSelect="onWorkMachineSelected"
                            :onDateSelected="onWorkMachineFilterDateSelected"
                            :error-message="colorFilterElementErrorMessage"
                          />

                          <layer-color-filter-element
                            :items="colorFilterItems"
                            v-show="selectedColorByType?.code == 'EQUIPMENT'"
                            @onSelect="onEquipmentSelected"
                            :onDateSelected="onEquipmentFilterDateSelected"
                            :error-message="colorFilterElementErrorMessage"
                          />
                          <layer-color-filter-element
                            :items="colorFilterItems"
                            v-show="selectedColorByType?.code == 'PRODUCT_TYPE'"
                            :onProductTypeSelected="onProductTypeSelected"
                            @onSelect="onProductCategorySelected"
                            :secondStep="true"
                            :show-date-range-checkbox="true"
                            :date-range-checkbox-value="filterProductTypesByCost"
                            :date-range-checkbox-label="$t('layer_colorizing.only_product_types_with_cost')"
                            @onDateRangeCheckboxChanged="onProductTypeCostCheckboxChanged"
                            :error-message="colorFilterElementErrorMessage"
                          />
                        </div>
                      </div>
                      <div class="layer-color-filter-bottom-spacer"></div>
                      <div class="apply_map_filter_sticky_dialog">
                        <b-button class="continue_button" variant="outline-secondary" size="sm" pill @click="applyMapColorFilter"
                          >Aplică</b-button
                        >
                      </div>
                    </div>
                  </DxScrollView>

                  <DxScrollView v-show="mainStep.id == 'COST_CALCULATION'">
                    <component
                      :is="mainStep.component"
                      :date-range="layerColorDateRange"
                      :getLayers="getLayers"
                      :get-cost-layers="getCostLayers"
                      :color-filter-items="colorFilterItems"
                      :colorFilterItemsSelections="colorFilterItemsSelections"
                      :current-tab="mainStep.id"
                      @onPrevStepSelect="onCostCalculationPrevStepSelect"
                      @onUpdatedCostRangeLayers="onUpdatedCostRangeLayers"
                    />
                  </DxScrollView>
                </div>
              </template>
            </DxTabPanel>
          </div>
        </template>
      </DxPopup>
      <toast-message ref="toastMessage"></toast-message>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxPopup from "devextreme-vue/popup";
import DxTabPanel from "devextreme-vue/tab-panel";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxSelectBox from "devextreme-vue/select-box";
import { FunctionalCalendar } from "vue-functional-calendar";
import { DxCheckBox } from "devextreme-vue/check-box";
import DxRadioGroup from "devextreme-vue/radio-group";
import ToastMessage from "../../components/Mobile/toastMessage.vue";
import { required, helpers } from "vuelidate/src/validators";
import LayerColorFilterElement from "@/components/Map/LayerColorFilterElement.vue";
import LayerColorCostCalculation from "@/components/Map/LayerColorCostCalculation.vue";

const requiredDates = (param) => (value) => {
  if (param) {
    return helpers.req(value);
  }
  return true;
};

const requiredWork = (param) => (value) => {
  if (param) {
    return helpers.req(value);
  }
  return true;
};

export default {
  name: "LayerColorFilter",
  components: {
    LayerColorFilterElement,
    LayerColorCostCalculation,
    DxPopup,
    DxTabPanel,
    DxScrollView,
    DxSelectBox,
    FunctionalCalendar,
    DxCheckBox,
    DxRadioGroup,
    ToastMessage,
  },
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
    filterIsActive: {
      type: Boolean,
      default: false,
    },
    heightDiff: {
      type: Number,
      default: 0,
    },
    season_uuid: {
      type: String,
      default: "",
    },
    getLayers: {
      type: Function | null,
    },
    getCostLayers: {
      type: Function | null,
    },
    layerFilters: {
      type: Object,
    },
  },
  data() {
    return {
      popupAttributes: {
        class: "map-color-filter-attribute-wrapper",
      },
      tabPanelAttributes: {
        class: "map-color-filter-steps",
      },
      checkBoxAttributes: {
        class: "color-code_checkbox",
      },
      radioGroupAttributes: {
        class: "color-code_radiogroup",
      },
      filterTabs: [
        { id: "STRATIFICARE", text: "STRATIFICARE" },
        { id: "COST_CALCULATION", text: "STRATIFICARE BAZA DE COST", component: LayerColorCostCalculation },
      ],
      currentColorFilterStep: 0,
      currentColorFilterItem: "STRATIFICARE",
      colorByTypes: [
        { code: "WORK", name: "Lucrare" },
        { code: "CULTURE", name: "Cultură" },
        { code: "SEASON", name: "An agricol" },
        { code: "LEGAL_ENTITY", name: "Societate" },
        { code: "PRODUCT", name: "Produs" },
        { code: "WORK_MACHINE", name: "Tractor" },
        { code: "EQUIPMENT", name: "Utilaj" },
        { code: "PRODUCT_TYPE", name: "Tip produs" },
      ],
      selectedColorByType: {},
      calendar: {
        dateRange: {
          start: "",
          end: "",
        },
      },
      cultures: [],
      localLayerWorks: [],
      formData: {
        colorByType: null,
        dateFrom: null,
        dateTo: null,
        work_uuid: null,
      },
      colorFilterElementErrorMessage: null,
      layerColorDateRange: null,
      colorFilterItemsSelections: [],
      colorFilterItems: [],
      colorFilterBackPath: null,
      colorFilterCallback: null,
      filterProductsBySelectedDateRange: false,
      filterProductTypesByCost: false,
      selectedProductTypeForFilter: null,
    };
  },
  watch: {
    showPopup: {
      handler: function (newVal) {
        if (newVal) {
          this.loadLayerWorks();
          if (!this.filterIsActive) {
            this.resetForm();
          }
        }
      },
      deep: true,
      immediate: true,
    },
    calendar: {
      handler(newVal) {
        if (newVal && newVal.hasOwnProperty("dateRange")) {
          this.formData.dateFrom = newVal.dateRange.start;
          this.formData.dateTo = newVal.dateRange.end;
        }
      },
      deep: true,
    },
  },
  validations() {
    return {
      formData: {
        colorByType: { required },
        dateFrom: { requiredDates: requiredDates(this.formData.colorByType == "WORK") },
        dateTo: { requiredDates: requiredDates(this.formData.colorByType == "WORK") },
        work_uuid: { requiredWork: requiredWork(this.formData.colorByType == "WORK") },
      },
    };
  },
  computed: {
    ...mapGetters({
      layers_loading: "layers/layers_loading",
      layer_season_uuid: "layers/layer_season_uuid",
      seasons: "seasons/seasons",
      layer_filters: "layers/layer_filters",
      departments: "company/departments",
    }),
    popupHeight() {
      return (80 - this.heightDiff).toString() + "vh";
    },
    layers() {
      let tmplayers = this.$store.getters["layers/layers"];
      return tmplayers;
    },
    layerWorks() {
      let tmplayerWorks = this.$store.getters["layers/layer_works"];
      return tmplayerWorks;
    },
    legalEntities() {
      return this.departments.filter((item) => {
        return item.is_legal_entity === 1;
      });
    },
  },
  methods: {
    ...mapActions({
      getLayersByWorkAndDate: "layers/getLayersByWorkAndDate",
      getLayerWork: "layers/getLayerWork",
      getFertilityProducts: "fertilityProduct/getFertilityProductsLight",
    }),
    resetForm() {
      this.formData = {
        colorByType: null,
        dateFrom: null,
        dateTo: null,
        work_uuid: null,
      };
      this.cultures = [];
      this.localLayerWorks = [];
      this.calendar = {
        dateRange: {
          start: "",
          end: "",
        },
      };
      this.filterProductsBySelectedDateRange = false;
      this.filterProductTypesByCost = false;
      this.selectedProductTypeForFilter = null;
    },
    onColorByTypeChanged(e) {
      this.selectedColorByType = this.colorByTypes.find((c) => c?.code == e.value);
      if (this.selectedColorByType?.code == "CULTURE") {
        let tmpCultures = this.layers.filter((obj) => obj.culture != null).map((obj) => obj.culture);
        this.cultures = [];
        tmpCultures.forEach((element) => {
          if (this.cultures.find((obj) => obj.uuid == element.uuid)) {
          } else {
            element.selected = true;
            this.cultures.push(element);
            element.color = element.color || this.generateColorCode();
          }
        });
      }
      if (this.selectedColorByType?.code == "WORK") {
        // this.localLayerWorks = this.layerWorks;
        this.localLayerWorks.forEach((element) => {
          element.selected = false;
          element.color = "#4ca7c4"; // this.generateColorCode()
        });
      }

      if (this.selectedColorByType?.code == "SEASON") {
        this.seasons.forEach((element) => {
          element.selected = element.uuid == this.season_uuid;
          element.color = this.generateColorCode();
        });
      }

      if (this.selectedColorByType?.code == "LEGAL_ENTITY") {
        this.legalEntities.forEach((element) => {
          element.selected = true;
          element.color = this.generateColorCode();
        });
      }

      //this.colorFilterBackPath = null;
    },
    generateColorCode() {
      let code = "#" + Math.floor(Math.random() * 16777215).toString(16);
      if (code == "#ffffff" || code == "#d3d3d3" || code == "#000000" || code.length != 7) {
        code = this.generateColorCode();
      }
      return code;
    },
    closeDialog() {
      this.$emit("hidden");
    },
    mainTabSelectionChanged(e) {
      this.currentColorFilterItem = e.addedItems[0];
      this.currentColorFilterStep = this.filterTabs.indexOf(this.currentColorFilterItem);
    },
    validateForm() {
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        if (this.$v.formData.colorByType.$invalid) {
          this.$refs.toastMessage.showError("Selectează tipul de colorizare!");
        } else if (this.$v.formData.dateFrom.$invalid) {
          this.$refs.toastMessage.showError("Selectează data!");
        } else if (this.$v.formData.dateTo.$invalid) {
          this.$refs.toastMessage.showError("Selectează data!");
        } else if (this.$v.formData.work_uuid.$invalid) {
          this.$refs.toastMessage.showError("Selectează o lucrare!");
        } else {
          this.$refs.toastMessage.showError("A apărut o eroare de validare!");
        }
      }
      return !this.$v.formData.$invalid;
    },
    applyMapColorFilter() {
      //redirect to back path  -tab
      if (this.colorFilterBackPath) {
        this.currentColorFilterStep = this.filterTabs.indexOf(this.filterTabs.find((t) => t.id === this.colorFilterBackPath));
        if (this.colorFilterCallback instanceof Function) {
          //reset
          this.colorFilterBackPath = null;
          //go back to next step
          this.colorFilterCallback();
          this.colorFilterCallback = null;
        }
        return;
      }

      if (this.validateForm()) {
        if (this.selectedColorByType?.code == "CULTURE") {
          this.$emit("applyColorFilterByCulture", this.cultures);
          this.$emit("hidden");
        }
        if (this.selectedColorByType?.code == "WORK") {
          this.getLayersByWorkAndDate({
            season_uuid: this.season_uuid,
            date_from: this.formData.dateFrom,
            date_to: this.formData.dateTo,
            work_uuid: this.formData.work_uuid.uuid,
          }).then((response) => {
            if (response.data.length <= 0) {
              this.$refs.toastMessage.showInfo("Căutarea nu a dat rezultat!");
            } else {
              this.$emit(
                "applyColorFilterByWork",
                this.localLayerWorks.find((w) => (w.uuid = this.formData.work_uuid.uuid)),
                response.data,
              );
              this.$emit("hidden");
            }
          });
        }
        if (this.selectedColorByType?.code == "SEASON") {
          this.$emit("applyColorFilterBySeason", this.seasons);
          this.$emit("hidden");
        }
        if (this.selectedColorByType?.code == "LEGAL_ENTITY") {
          this.$emit("applyColorFilterByLegalEntity", this.legalEntities);
          this.$emit("hidden");
        }
        if (this.selectedColorByType?.code == "PRODUCT") {
          const selectedItems = this.colorFilterItems.filter((item) => item.selected);

          if (selectedItems.length > 0) {
            //this is radio button, only one selected!
            this.$emit("applyColorFilterByProduct", selectedItems[0]);
            this.$emit("hidden");
          }
        }
        if (this.selectedColorByType?.code == "WORK_MACHINE") {
          const selectedItems = this.colorFilterItems.filter((item) => item.selected);

          if (selectedItems.length > 0) {
            //this is radio button, only one selected!
            this.$emit("applyColorFilterByWorkMachine", selectedItems[0]);
            this.$emit("hidden");
          }
        }
        if (this.selectedColorByType?.code == "EQUIPMENT") {
          const selectedItems = this.colorFilterItems.filter((item) => item.selected);

          if (selectedItems.length > 0) {
            //this is radio button, only one selected!
            this.$emit("applyColorFilterByEquipment", selectedItems[0]);
            this.$emit("hidden");
          }
        }
        if (this.selectedColorByType?.code == "PRODUCT_TYPE") {
          const selectedItems = this.colorFilterItems.filter((item) => item.selected);

          if (selectedItems.length > 0) {
            //this is radio button, only one selected!
            this.$emit("applyColorFilterByProductType", selectedItems[0]);
            this.$emit("hidden");
          }
        }
      }
    },
    bgColor(culture) {
      return {
        "background-color": culture.color,
      };
    },
    loadLayerWorks(params) {
      return new Promise((resolve, reject) => {
        this.getLayerWork({
          department_uuid: this.layer_filters?.department_uuids ? this.layer_filters.department_uuids.join(",") : "",
          season_uuid: this.layer_filters.season_uuid,
          ...params,
        })
          .then((response) => {
            this.localLayerWorks = response;
            resolve(response);
          })
          .catch((e) => {
            console.log("unable to load layers for works", e);
            reject(e);
          });
      });
    },
    //filter by product
    onProductFilterDateSelected(dateRange) {
      if (this.getLayers instanceof Function) {
        this.getLayers({
          attach_query: "product",
          stopFitBounds: true,
          strict_product_date_filter: this.filterProductsBySelectedDateRange ? 1 : 0,
          ...dateRange,
        })
          .then((resp) => {
            this.colorFilterItems = [
              ...new Map(
                resp.data
                  .flatMap((layer) => layer.input_products || [])
                  .map((prod) => [prod.uuid, { ...prod, color: this.generateColorCode() }]),
              ).values(),
            ].sort((a, b) => a.name.localeCompare(b.name));
            this.layerColorDateRange = dateRange;
          })
          .catch((e) => {
            this.setColorFilterError(e);
          });
      }
    },
    onProductDateRangeCheckboxChanged(enabled) {
      this.filterProductsBySelectedDateRange = Boolean(enabled);

      if (this.layerColorDateRange && this.getLayers instanceof Function) {
        this.onProductFilterDateSelected(this.layerColorDateRange);
      }
    },
    onProductSelected(productUUID) {
      this.colorFilterItems.map((prod) => {
        if (prod.selected) {
          prod.selected = false;
        }

        if (prod.uuid === productUUID) {
          prod.selected = true;
          this.colorFilterItemsSelections = [prod];
        }

        return prod;
      });
    },
    //filter by work machine
    onWorkMachineFilterDateSelected(dateRange) {
      if (this.getLayers instanceof Function) {
        this.getLayers({ attach_query: "work_machine", stopFitBounds: true, ...dateRange })
          .then((resp) => {
            this.colorFilterItems = [
              ...new Map(
                resp.data.flatMap((layer) => layer.work_machine || []).map((wm) => [wm.uuid, { ...wm, color: this.generateColorCode() }]),
              ).values(),
            ].sort((a, b) => a.name.localeCompare(b.name));
            this.layerColorDateRange = dateRange;
          })
          .catch((e) => {
            this.setColorFilterError(e);
          });
      }
    },
    onWorkMachineSelected(workMachineUUID) {
      this.colorFilterItems.map((wm) => {
        if (wm.selected) {
          wm.selected = false;
        }

        if (wm.uuid === workMachineUUID) {
          wm.selected = true;
          this.colorFilterItemsSelections = [wm];
        }

        return wm;
      });
    },
    //filter by equipment
    onEquipmentFilterDateSelected(dateRange) {
      if (this.getLayers instanceof Function) {
        this.getLayers({ attach_query: "equipment", stopFitBounds: true, ...dateRange })
          .then((resp) => {
            this.colorFilterItems = [
              ...new Map(
                resp.data.flatMap((layer) => layer.equipment || []).map((wm) => [wm.uuid, { ...wm, color: this.generateColorCode() }]),
              ).values(),
            ].sort((a, b) => a.name.localeCompare(b.name));
            this.layerColorDateRange = dateRange;
          })
          .catch((e) => {
            this.setColorFilterError(e);
          });
      }
    },
    onEquipmentSelected(equipmentUUID) {
      this.colorFilterItems.map((wm) => {
        if (wm.selected) {
          wm.selected = false;
        }

        if (wm.uuid === equipmentUUID) {
          wm.selected = true;
          this.colorFilterItemsSelections = [wm];
        }

        return wm;
      });
    },
    //filter by product type = fito, fertility, stock
    onProductTypeSelected(productType, dateRange) {
      this.selectedProductTypeForFilter = productType;

      if (this.getLayers instanceof Function) {
        return new Promise((resolve, reject) => {
          this.getLayers({
            attach_query: "product",
            stopFitBounds: true,
            include_cost_product_type_uuids: this.filterProductTypesByCost ? 1 : 0,
            ...dateRange,
          })
            .then((resp) => {
              let productTypeItems = Object.assign(
                [],
                [
                  ...new Map(
                    resp.data
                      .flatMap((layer) => layer.input_products || [])
                      .filter((prod) => prod?.category_uuid && prod?.category_name && prod.product_type === productType)
                      .map((prod) => [
                        prod.category_uuid,
                        {
                          color: this.generateColorCode(),
                          uuid: prod.category_uuid,
                          name: prod.category_name,
                        },
                      ]),
                  ).values(),
                ],
              ).sort((a, b) => a.name.localeCompare(b.name));

              if (this.filterProductTypesByCost) {
                const productTypeWithCostUuids = new Set(resp.data.flatMap((layer) => layer.cost_product_type_uuids || []).filter(Boolean));

                productTypeItems = productTypeItems.filter((item) => productTypeWithCostUuids.has(item.uuid));
              }

              this.colorFilterItems = productTypeItems;
              this.layerColorDateRange = dateRange;
              resolve(this.colorFilterItems);
            })
            .catch((e) => {
              this.setColorFilterError(e);
              reject(e);
            });
        });
      }
    },
    onProductTypeCostCheckboxChanged(enabled) {
      this.filterProductTypesByCost = Boolean(enabled);

      if (this.layerColorDateRange && this.selectedProductTypeForFilter && this.getLayers instanceof Function) {
        this.onProductTypeSelected(this.selectedProductTypeForFilter, this.layerColorDateRange);
      }
    },
    onProductCategorySelected(productCategoryUUID) {
      this.colorFilterItems.map((pc) => {
        if (pc.selected) {
          pc.selected = false;
        }

        if (pc.uuid === productCategoryUUID) {
          pc.selected = true;
          this.colorFilterItemsSelections = [pc];
        }

        return pc;
      });
    },
    //cost calculation
    onUpdatedCostRangeLayers(updatedCostRangeLayers, selectedCostRanges) {
      this.$emit("onLayerColorCostCalculationUpdated", updatedCostRangeLayers, selectedCostRanges);
    },
    setColorFilterError(errorResponse) {
      if (errorResponse.response.status === 500 && errorResponse.response.data.errors) {
        //this.colorFilterElementErrorMessage = errorResponse.response.data.errors.error[0]; //full trace
        this.colorFilterElementErrorMessage = this.$t("general_error");
      }
    },
    onCostCalculationPrevStepSelect(costPerHaSelection) {
      this.selectTab(costPerHaSelection);
      this.colorFilterBackPath = costPerHaSelection.back_path;
      this.colorFilterCallback = costPerHaSelection.callback;
    },
    selectTab(costPerHaSelection) {
      //select tab
      this.currentColorFilterStep = this.filterTabs.indexOf(this.filterTabs.find((t) => t.id === costPerHaSelection.step1_tab));
      //select type
      this.onColorByTypeChanged({
        value: costPerHaSelection.step1_type,
      });
      this.formData.colorByType = costPerHaSelection.step1_type;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/components/layerColorFilter.scss";
</style>
